export class RateDto {
    currencyPair: string;
    bid: string;
    offer: string;
    bidUpdatedAt: string;
    offerUpdatedAt: string;
}
